// extracted by mini-css-extract-plugin
module.exports = {"square":"LegendItem-module--square--3r-LP"};